export const setUserInLocalStorage = (user) => {
  localStorage.setItem('user', JSON.stringify(user));
};

export const getUserFromLocalStorage = () => {
  return JSON.parse(localStorage.getItem('user'));
};

export const removeUserFromLocalStorage = () => {
  localStorage.removeItem('user');
};

export const getTokenFromLocalStorage = () => {
  return localStorage.getItem('token');
};

export const removeTokenFromLocalStorage = () => {
  localStorage.removeItem('token');
};

export const setAuthToken = (token) => {
  localStorage.setItem('token', token);
};

export const logout = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
};
